module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('nav', {
    class: ("dn-local-navi dn-local-navi--" + _vm.id)
  }, [_c('h3', {
    staticClass: "dn-local-navi__ttl",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dn-local-navi__body"
  }, [_vm._l((_vm.groups), function(group) {
    return [(group.label) ? _c('span', {
      key: group.id + '-label',
      staticClass: "dn-local-navi__link dn-local-navi__label",
      domProps: {
        "innerHTML": _vm._s(group.label)
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((group.links), function(link) {
      return _c('a', {
        directives: [{
          name: "linkset",
          rawName: "v-linkset",
          value: (link.url_id),
          expression: "link.url_id"
        }],
        key: link.id,
        staticClass: "dn-local-navi__link",
        class: {
          'dn-local-navi__link--active': link.matched
        },
        attrs: {
          "href": link.href,
          "target": link.target
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(link.label)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-icon dn-icon-arrow-right"
      })])
    })]
  })], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9b65bd6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/navigations/LocalNavi.vue
// module id = 368
// module chunks = 1